import React, { Component } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { NavigateFunction, useParams, useNavigate } from 'react-router-dom'
import type { State } from 'types/redux'
import {
  finalizeTrackUpload,
  resetTrackUploads,
  uploadTrackFileToS3,
} from '@disco/state-management/actions/TrackUploaderActions'
import { getTrack } from '@disco/state-management/selectors/tracks'
import DocumentHeadTags from 'components/document-head-tags'
import UploadTrackFile from 'components/modals/track/upload-track-file'
import type { RootState } from 'store/configureStore'
interface OwnProps {
  params: {
    trackId: string
  }
  navigate: NavigateFunction
}

function mapStateToProps(state: RootState, props: OwnProps) {
  return {
    trackUploader: state.trackUploader,
    track: getTrack(state, {
      id: parseInt(props.params.trackId, 10),
    }),
  }
}

const mapDispatchToProps = {
  uploadTrackFileToS3,
  finalizeTrackUpload,
  resetTrackUploads,
}

const connector = connect(mapStateToProps, mapDispatchToProps)

type PropsFromRedux = ConnectedProps<typeof connector>
type AddTrackFormatProps = PropsFromRedux & OwnProps

class AddTrackFormat extends Component<AddTrackFormatProps> {
  abortController: AbortController | null = null

  constructor(props: any) {
    super(props)
    this.abortController = null
  }

  componentWillUnmount() {
    this._cancelUploads()

    this.props.resetTrackUploads()
  }

  _cancelUploads() {
    if (this.abortController) this.abortController.abort()
  }

  _handleUpload = abortController => {
    this._cancelUploads()

    this.abortController = abortController
  }
  _onClose = () =>
    this.props.navigate(`/explorer/tracks/${this.props.track.id}/formats`)
  _onDone = () => this.props.navigate('/')

  _getFormatForAdding() {
    // adding is allowed only if 1 format is present
    const [firstFormat] = Object.keys(this.props.track.all_files || {})
    return firstFormat
  }

  render() {
    return (
      <div>
        <DocumentHeadTags
          title={`Add format for ${this.props.track.name} | DISCO`}
        />
        <UploadTrackFile
          isAdding
          trackUploader={this.props.trackUploader}
          track={this.props.track}
          existingFormat={this._getFormatForAdding()}
          uploadTrackFileToS3={this.props.uploadTrackFileToS3}
          finalizeTrackUpload={this.props.finalizeTrackUpload}
          onUpload={this._handleUpload}
          onClose={this._onClose}
          onDone={this._onDone}
        />
      </div>
    )
  }
}

const ConnectedAddTrackFormat = connector(AddTrackFormat)

// Wrapper component to provide router params and navigation to the connected component
const AddTrackFormatWithRouter = (props: any) => {
  const params = useParams<{ trackId: string }>()
  const navigate = useNavigate()

  return (
    <ConnectedAddTrackFormat {...props} params={params} navigate={navigate} />
  )
}

export default AddTrackFormatWithRouter
